import { environment } from 'projects/heorot/src/app/environments/environment';
import { inject, Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  UrlTree,
} from '@angular/router';
import { ProjectName } from '../enums/project-name.enum';
import { UserRoles } from '../enums/user-roles.enum';
import { AuthStore } from '../../store/auth.store';

@Injectable({
  providedIn: 'root',
})
export class CanActivateUser implements CanActivate {
  private readonly authStore = inject(AuthStore);

  async canActivate(
    route: ActivatedRouteSnapshot,
  ): Promise<boolean | UrlTree> {

    if (!this.authStore.isAuthenticated()) {
      await this.authStore.refreshAuthInfo();
    }

    const isProd = environment.production;

    await Promise.all([
      this.authStore.waitForAuthReadyAsync(isProd ? 500 : 5000, 'url-allowed.guard'),
      this.authStore.waitForAccountReadyAsync(isProd ? 500 : 5000, 'url-allowed.guard')
    ]);

    if (!this.authStore.isAuthenticated()) {
      return false;
    }

    const account = this.authStore.account();
    if (account) {
      const project = <string>route.data['project'];
      const roles = account?.roles || [];

      switch (project) {
        case ProjectName.Bareka:
        case ProjectName.Rekensprint:
        case ProjectName.ATR:
          if (!roles.filter((r) => r.name === UserRoles.Student).length || roles.filter((r) => r.name === UserRoles.Supervisor).length > 0) {
            this.logoutAndGoToDashboard(project);
            return false;
          } else {
            const licenses = account?.licenses || [];
            if (project === ProjectName.Bareka && !licenses.filter(l => l.name === 'Test').length) {
              this.logoutAndGoToDashboard(project);
              return false;
            }
            if (project === ProjectName.Rekensprint && !licenses.filter(l => l.name === 'Program').length) {
              this.logoutAndGoToDashboard(project);
              return false;
            }
            if (project === ProjectName.ATR && !licenses.filter(l => l.name === 'ATR').length) {
              this.logoutAndGoToDashboard(project);
              return false;
            }
          }
          break;
        case ProjectName.Heorot:
          if (!roles.filter((r) => r.name === UserRoles.Supervisor).length || roles.filter((r) => r.name === UserRoles.Student).length > 0) {
            this.logoutAndGoToDashboard(project);
            return false;
          }
          break;
      }

      return true;
    }

    return false;
  }

  private async logoutAndGoToDashboard(project: ProjectName) {
    this.authStore.logoutLocal();
    console.log(`Current user doesn't have necessary roles for using ${project}. Redirecting to Lexipoort...`);
    window.location.href = environment.lexipoort.dashboard;
  }
}
